import * as actionTypes from "../actionTypes";

const initialState = {
  loading: false,
  servicesList: null,
  servicesListError: null,
  servicesData: null,
  servicesDataError: null,
  success: null,
  error: null,
};

export const servicesReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_SERVICES_LIST_START:
      return {...state, loading: true, servicesListError: null, error: null, success: null};
    case actionTypes.GET_SERVICES_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        servicesListError: null,
        servicesList: action.payload,
      }
    }
    case actionTypes.GET_SERVICES_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        servicesListError: action.payload,
        servicesList: null,
      };
    case actionTypes.GET_SERVICES_DATA_START:
      return {...state, loading: true, servicesDataError: null, error: null, success: null};
    case actionTypes.GET_SERVICES_DATA_SUCCESS: {
      return {
        ...state,
        loading: false,
        servicesDataError: null,
        servicesData: action.payload,
      }
    }
    case actionTypes.GET_SERVICES_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        servicesDataError: action.payload,
        servicesData: null,
      };

    case actionTypes.SERVICE_MESSAGE_HANDLER:
      return {
        ...state,
        loading: false,
        servicesListError: action.payload,
        userDataError: action.payload,
        error: action.payload,
        success: action.payload,
      };
    default:
      return {...state};
  }
};
